import { render, staticRenderFns } from "./AccountParams.vue?vue&type=template&id=636707e5&scoped=true&"
import script from "./AccountParams.vue?vue&type=script&lang=js&"
export * from "./AccountParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636707e5",
  null
  
)

export default component.exports